import React from "react"
import PropTypes from "prop-types"
import "./marketing.scss"
import calendar from "../../images/splashScreens/talktalk-calendar.png"
import hub from "../../images/splashScreens/talktalk-signal.png"
import guarantee from "../../images/splashScreens/talktalk-guarantee.png"

import Button from "../shared/button/text-button"

const MarketingTalkTalk = ({ handleButtonClick }) => (
  <div className="marketing-page marketing-page--talktalk">
    <h1>FAST RELIABLE FIBRE</h1>
    <div className="marketing-page--info">
      <div className="marketing-page--info--image">
        <img src="images/marketing/talktalk.jpg" alt="" />
      </div>
      <div className="marketing-page--info--text">
        <p>
          Here’s to the flatsharers, the winners, the weepers and the
          multi-screeners! Our fibre broadband is there for you, whoever you
          are, whatever your thing is. ​ ​
        </p>
        <p>
          With our state of the art WiFi Hub we deliver you superfast fibre
          internet at a fairer and cheaper price. Best of all, if you are not
          happy within 30 days then you are free to leave.
        </p>
      </div>
    </div>
    <div className="marketing-page--extras">
      <p className="bold">
        Our award-winning, Faster Fibre. Fairer broadband for non-stop streamers
        and always-onliners
      </p>
      <div className="thumbnailContainer">
        <div>
          <img src={calendar} alt="" />
          <p className="bold">No Price Rises​</p>

          <p>
            No broadband price rises for the duration of your contract,
            guaranteed
          </p>
        </div>
        <div>
          <img src={hub} alt="" />
          <p className="bold">WiFi Hub</p>
          <p>
            Our new Wi-Fi Hub. You won’t get a better Wi-Fi signal from any of
            the other big providers
          </p>
        </div>
        <div>
          <img src={guarantee} alt="" />
          <p className="bold">30-days guarantee​</p>
          <p>
            ​ 30 days to love your new fibre connection, or you’re free to
            leave.
          </p>
        </div>
      </div>
    </div>
    <div className="marketing-button-container">
      <Button text="Continue" onClick={handleButtonClick} />
    </div>
  </div>
)

MarketingTalkTalk.propTypes = {
  handleButtonClick: PropTypes.func.isRequired
}

export default MarketingTalkTalk
